import React, { useRef, useState } from "react";
import api from "../../lib/api";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { toast } from "sonner";
import { Upload, CheckCircle2 } from "lucide-react";

export const ProofUpload = ({ numero, already }) => {
  const [tel, setTel] = useState(() => sessionStorage.getItem("yoyo_last_phone") || "");
  const [file, setFile] = useState(null);
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(already);
  const ref = useRef();

  const send = async () => {
    if (!file) { toast.error("Choisissez la capture de votre paiement"); return; }
    if (tel.replace(/\D/g, "").length < 8) { toast.error("Indiquez le téléphone utilisé pour la commande"); return; }
    const fd = new FormData();
    fd.append("telephone", tel);
    fd.append("file", file);
    setSending(true);
    try {
      await api.post(`/orders/${numero}/preuve`, fd);
      setDone(true);
      toast.success("Preuve de paiement envoyée !");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Envoi impossible, réessayez");
    } finally {
      setSending(false);
    }
  };

  if (done) {
    return (
      <div className="mt-3 flex items-center gap-2 rounded-xl bg-[#E8F8EE] p-4 text-sm text-[#1da851]" data-testid="proof-success">
        <CheckCircle2 className="h-5 w-5 shrink-0" /> Preuve reçue ! Nous vérifions votre paiement et revenons vers vous très vite.
      </div>
    );
  }
  return (
    <div className="mt-3 space-y-3 rounded-xl bg-[#F5E8E3] p-4" data-testid="proof-upload">
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="proof-file-input" />
      <button type="button" onClick={() => ref.current?.click()} data-testid="proof-pick"
        className="flex w-full items-center justify-center gap-2 rounded-lg border-2 border-dashed border-[#D76E4D] bg-white px-4 py-4 text-sm text-[#2C1A14] transition-colors hover:bg-[#FBF1EE]">
        <Upload className="h-4 w-4 text-[#D76E4D]" />
        <span className="truncate">{file ? file.name : "Choisir la capture d'écran du paiement"}</span>
      </button>
      <Input value={tel} onChange={(e) => setTel(e.target.value)} placeholder="Téléphone de la commande" inputMode="tel" data-testid="proof-tel" className="bg-white" />
      <Button onClick={send} disabled={sending} data-testid="proof-submit" className="w-full rounded-full bg-[#D76E4D] py-5 text-white hover:bg-[#C05A3A]">
        {sending ? "Envoi..." : "Envoyer ma preuve de paiement"}
      </Button>
    </div>
  );
};
